<template>
    <div>
        <HeaderTopComponent v-if="!menuMovil" />
        <MenuComponent 
            background='' 
            :dense='false' 
            styleRow='margin-top: 0px'
            v-if="!menuMovil"
        />
        <MenuMovilComponent v-if="menuMovil" class='px-6 px-sm-10'/>
        <v-img 
            :src="`${require('@/assets/banner-sedes.png')}`" 
            v-if="$route.path != '/servicios/pacientes/medicamentos-especialidad'"
            :class="`${scrollTop ? '' : 'mt-132'}`"
        />
        <BreadCrumbsComponent :breadcrumbs="breadcrumbs" class="margin-breadcrumb"/>
        <div 
            class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-6" 
            v-if="$route.path == '/sedes'"
        >
            <v-row>
                <v-col 
                    cols="12" md="6"
                    v-for="(sede, i) in sedes"
                    :key="i"
                >
                    <h2 class="font-size-custom font-weight-bold color-title font-title"><i>Sede {{ sede.sedeName }}</i></h2>
                    <div 
                        class="pointer-card-services mt-10"
                        v-for="(service, x) in sede.services"
                        :key="x"
                        @click="setSedeServ(service)"
                        v-if="service.content_id!=null"
                    >
                        <CardServiciosComponent 
                            classCard='color-border-card'
                            :icon="`${domain}img/web_commerce/${service.sedeImg}`"
                            :title="`<div class='text-body-1 text-sm-h5 text-md-h5 gray--text '><b>${service.service}</b></div>`"
                            link="/sedes/servicio"
                        />
                    </div>
                </v-col>
            </v-row>
        </div>
        <router-view :servicio = servicio></router-view>
        <FooterComponent />
    </div>
</template>

<script>

import {mapState, mapMutations, mapActions} from 'vuex'
import HeaderTopComponent from '../partials/HeaderTopComponent'
import MenuComponent from '../partials/MenuComponent'
import FooterComponent from '../partials/FooterComponent'
import BreadCrumbsComponent from '../partials/BreadCrumbsComponent'
import CardServiciosComponent from '../partials/CardServiciosComponent'
import MenuMovilComponent from '../partials/MenuMovilComponent'

export default {
    name:'IndexComponent',
    data: ()=>({
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Sedes',url:'/sedes'}
        ],
        sedes:[],
        servicio :{},
        domain: process.env.VUE_APP_NODE_ENV === "production" ? process.env.VUE_APP_API_URL_PROD : process.env.VUE_APP_API_URL_DEVEL,
    }),
    components:{
        HeaderTopComponent,
        MenuComponent,
        FooterComponent,
        BreadCrumbsComponent,
        CardServiciosComponent, 
        MenuMovilComponent
    },
    watch:{
        $route(to) {
             if(to.path == '/sedes') 
                this.breadcrumbs = [
                    {name:'Inicio',url:'/'},
                    {name:'Sedes',url:'/sedes'}
                ]  
        }
    },
    computed:{

        menuMovil(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs'
        },

        ...mapState(['scrollTop'])

    },
    methods:{

        ...mapActions(['errorRequest','requestApi','alertNotification']),

        ...mapMutations(['setUrl','setLoadingBtn','setTitleToolbar','setSedeService']),

        setSedeServ(serv){
            this.servicio= serv
            this.breadcrumbs = [
                {name:'Inicio',url:'/'},
                {name:'Sedes',url:'/sedes'},
                {name:serv.sedeName, url:'/sedes'}
            ]  

        },

        getSedes(){

            this.setUrl('administracion')

            this.requestApi({
                method: 'GET',
                data :{
                    typeList:'dataWeb',
                    all:'false'
                }
            }).then(res =>{

                this.sedes = res.data._embedded.administracion.filter(e => e.content_type_id == 'OWNER_SEDE')
                .map(obj=>{ 

                    const  { content_id,content_name } = obj
                    let ctnId = content_id
                    let ctnName = content_name

                    let services = res.data._embedded.administracion.filter(e => e.owner_content_id == content_id)
                    .map(ele => {
            
                        const  { content_id, service_name, content_name, extra, description } = ele

                        return {
                            owner_content_id: ctnId,
                            sedeName:ctnName,
                            content_id:content_id,
                            sedeImg: content_name,
                            service: service_name,
                            sedeUrlMaps:extra,
                            sedeDescription: description,
                        }
                        
                    })

                    if(!services.length){

                        services.push({
                            owner_content_id: ctnId,
                            content_id:null,
                            sedeImg: null,
                            sedeName: content_name,
                            sedeUrlMaps:null,
                            sedeDescription: null,
                        })

                    }
                        
                    return {
                        content_id_sede: content_id,
                        sedeName: content_name,           
                        services,
                    }

                })

            }).then(()=>{
                
            })

        },

    },
    created(){
        this.getSedes()
    }
}
</script>

<style>
    .pointer-card-services{
        cursor: pointer;
    }
    .color-border-card{
        border: 3px solid #50c995!important;
        border-radius: 20px!important;
    }
    .img-dialog-description{
        max-width: 70px;
        background: #ffaa45;
        padding: 8px;
        border-radius: 10px;
    }
    .v-application .text-md-h3, .v-application .text-md-h5{
        font-family: Asap!important
    }

    .row{
        width: 100%;
    }
    
</style>